export const setupCopyIt = {
    yourHospitalNumber: "Il Suo numero di cartella clinica",
    hospitalNumberIntro:
        "Il Suo numero di cartella clinica consente di identificarLa nel sistema dell'ospedale. Se il Suo medico Le ha assegnato un numero, lo inserisca qui.",
    hospitalNumberFieldHint: "Consente di identificarLa nel sistema dell'ospedale.",
    dontKnow: "Non lo so",
    skipForNow: "Non lo so ancora",
    whichSideAffectedTitle: "Quale lato del Suo corpo è interessato?",
    sideSetupLeadInTrackersOnly:
        "Dobbiamo sapere quale lato del Suo corpo è interessato per porLe le domande giuste sui questionari seguenti: ",
    sideSetupLeadInProceduresOnly: "Dobbiamo sapere quale lato del Suo corpo è interessato per farlo corrispondere a: ",
    sideSetupLeadInBoth:
        "Dobbiamo sapere quale lato del Suo corpo è interessato per porLe le domande giuste sui questionari seguenti e sul Suo trattamento: ",
    sideSetupBothSidesNote:
        "Se sono interessati entrambi i lati, scelga « Entrambi » e aggiungeremo un questionario per ciascun lato.",
    saveDate: "Salva la data",
    pickDate: "Scegli una data",
    clearDateAndTime: "Cancella data e ora",
    missingReferenceDateDataError:
        "Impossibile salvare la data dell'intervento - identificativi dei dati mancanti. Aggiorni la pagina o contatti l'assistenza se il problema persiste.",
    referenceDateMinMessage: "Scelga una data al massimo 2 anni fa.",
    referenceDateMaxMessage: "Scelga una data al massimo tra 2 anni.",
    referenceDateQuestion: (kind) => {
        if (kind === "product") return "Inizio del trattamento";
        if (kind === "injection") return "In quale data ha avuto o avrà l'iniezione?";
        if (kind === "surgery") return "In quale data ha avuto o avrà l'operazione?";
        if (kind === "medication") return "In quale data ha iniziato o inizierà il farmaco?";
        if (kind === "shockwave") return "In quale data ha iniziato o inizierà la terapia con onde d'urto?";
        if (kind === "consultation") return "In quale data ha avuto o avrà la visita?";
        return "In quale data ha avuto o avrà l'intervento?";
    },
    referenceDateDescriptionFor: (phrase, kind) => {
        if (kind === "product") {
            return `Quando ha iniziato (o inizierà) a usare ${phrase}? Indichi la data di inizio del Suo trattamento, passata o futura. Questo ci consente di porLe le domande di controllo giuste.`;
        }
        if (kind === "injection") {
            return `Scelga la data della Sua iniezione - passata o futura - in modo che le domande di controllo vi corrispondano.`;
        }
        if (kind === "shockwave") {
            return `Scelga la data della Sua terapia con onde d'urto - passata o futura - in modo che le domande di controllo vi corrispondano.`;
        }
        if (kind === "surgery") {
            return `Scelga la data del Suo intervento (${phrase}) - passata o futura - in modo che le domande di controllo vi corrispondano.`;
        }
        if (kind === "consultation") {
            return `Scelga la data della Sua visita - passata o futura - in modo che le domande di controllo vi corrispondano.`;
        }
        return `Scelga la data del Suo intervento (${phrase}) - passata o futura - in modo che le domande di controllo vi corrispondano.`;
    },
    productStartDateLabel: (phrase) => `Inizio del trattamento: ${phrase}`,
    chooseDateError: (phrase) => `Scelga la data del Suo intervento (${phrase})`,
    chooseProductStartDateError: (phrase) => `Indichi quando ha iniziato a usare ${phrase}`,
    savedProcedureDateToast: (phrase) => `La data del Suo intervento (${phrase}) è stata salvata.`,
    savedProductStartDateToast: (phrase) => `La data di inizio per ${phrase} è stata salvata.`,
};
